var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxHomeCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50018 11.3333H3.33351V12.9999V17.1666C3.33351 18.0858 4.08101 18.8333 5.00018 18.8333H15.0002C15.9193 18.8333 16.6668 18.0858 16.6668 17.1666V12.9999V11.3333H17.5002C17.8368 11.3333 18.1418 11.1299 18.2702 10.8191C18.3993 10.5074 18.3277 10.1491 18.0893 9.91076L10.5893 2.41076C10.2635 2.08492 9.73684 2.08492 9.41101 2.41076L1.91101 9.91076C1.67268 10.1491 1.60101 10.5074 1.73018 10.8191C1.85934 11.1299 2.16351 11.3333 2.50018 11.3333ZM10.0002 4.17826L15.0002 9.17826V12.9999L15.001 17.1666H5.00018V12.9999V10.4999V9.1791L10.0002 4.17826Z",
    fill: "#A6B0CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.6667C11.8384 14.6667 13.3334 13.1717 13.3334 11.3333C13.3334 9.495 11.8384 8 10 8C8.16169 8 6.66669 9.495 6.66669 11.3333C6.66669 13.1717 8.16169 14.6667 10 14.6667ZM9.99972 9.66667C10.9189 9.66667 11.6664 10.4142 11.6664 11.3333C11.6664 12.2525 10.9189 13 9.99972 13C9.08055 13 8.33305 12.2525 8.33305 11.3333C8.33305 10.4142 9.08055 9.66667 9.99972 9.66667Z",
    fill: "#A6B0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxHomeCircle);
export default __webpack_public_path__ + "static/media/bx-home-circle.6acaa836.svg";
export { ForwardRef as ReactComponent };